"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var antd_1 = require("antd");
var IconSelectorWindow_1 = __importDefault(require("../../IconSelectorWindow/IconSelectorWindow"));
require("./ImageField.css");
/**
 * ImageField
 */
var ImageField = /** @class */ (function (_super) {
    __extends(ImageField, _super);
    function ImageField(props) {
        var _this = _super.call(this, props) || this;
        _this.getIconSelectorButton = function () {
            var tooltipLabel = _this.props.tooltipLabel;
            return (React.createElement(antd_1.Tooltip, { title: tooltipLabel },
                React.createElement(antd_1.Icon, { className: "gs-image-field-gallery-icon", type: "picture", onClick: _this.openWindow })));
        };
        _this.openWindow = function () {
            _this.setState({
                windowVisible: true
            });
        };
        _this.closeWindow = function () {
            _this.setState({
                windowVisible: false
            });
        };
        _this.state = {
            windowVisible: false
        };
        return _this;
    }
    ImageField.prototype.render = function () {
        var _a = this.props, value = _a.value, placeholder = _a.placeholder, onChange = _a.onChange, iconLibraries = _a.iconLibraries;
        var windowVisible = this.state.windowVisible;
        return (React.createElement("div", { className: "editor-field gs-image-field" },
            React.createElement(antd_1.Input, { className: iconLibraries ? 'gs-image-field-gallery-addon' : undefined, value: value, placeholder: placeholder, defaultValue: value, addonAfter: iconLibraries ? this.getIconSelectorButton() : undefined, onChange: function (evt) {
                    if (onChange) {
                        onChange(evt.target.value);
                    }
                } }),
            !windowVisible ? null :
                React.createElement(IconSelectorWindow_1.default, { onClose: this.closeWindow, iconLibraries: iconLibraries, selectedIconSrc: value, onIconSelect: function (src) {
                        if (onChange) {
                            onChange(src);
                        }
                    } })));
    };
    ImageField.defaultProps = {
        tooltipLabel: 'Open Gallery',
        placeholder: 'URL to image'
    };
    return ImageField;
}(React.PureComponent));
exports.ImageField = ImageField;
exports.default = ImageField;
//# sourceMappingURL=ImageField.js.map